import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

// `result` is the JSON returned by a bulk-import endpoint; null closes the dialog.
export default function ImportResultDialog({ result, onClose, duplicatesKey = "adm.import.duplicates", hintKey = "adm.import.duplicates_hint" }) {
  const { t } = useLang();
  const duplicates = result?.duplicates || [];
  const errors = result?.errors || [];
  const errorCount = result?.error_count || 0;
  const duplicateCount = result?.duplicate_count || 0;

  return (
    <Dialog open={!!result} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>{t("adm.import.title")}</DialogTitle></DialogHeader>
        {result && (
          <div className="space-y-3 text-sm">
            <p className="font-semibold text-emerald-700">{t("adm.import.imported", { count: result.imported })}</p>
            {duplicateCount > 0 && (
              <div className="space-y-1">
                <p className="font-semibold text-amber-700">{t(duplicatesKey, { count: duplicateCount })}</p>
                <p className="text-xs text-slate-500">{t(hintKey)}</p>
                <p className="text-xs font-mono text-slate-600 break-all">{duplicates.join(", ")}</p>
              </div>
            )}
            {errorCount > 0 && (
              <div className="space-y-1">
                <p className="font-semibold text-red-700">{t("adm.import.errors", { count: errorCount })}</p>
                <ul className="max-h-48 overflow-y-auto text-xs text-slate-600 space-y-0.5">
                  {errors.map((e, i) => (
                    <li key={i}>
                      {t("adm.import.row", { row: e.row })}: {t(`adm.import.reason.${e.reason}`)}
                      {e.asin ? <span className="font-mono"> ({e.asin})</span> : null}
                    </li>
                  ))}
                </ul>
                {errorCount > errors.length && <p className="text-xs text-slate-400">{t("adm.import.more", { count: errorCount - errors.length })}</p>}
              </div>
            )}
          </div>
        )}
        <DialogFooter>
          <Button onClick={onClose} className="bg-blue-600 hover:bg-blue-700">{t("common.close")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
